<h2 class="title px-5">
  <span (click)="returnToList()" class="material-icons link mr-1">chevron_left</span>
  Nuevo Torneo
</h2>
<form action="#" [formGroup]="newTournamentForm" autocomplete="off" (submit)="saveTournament()">
  <div class="new_tournament__container" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="1rem">

    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Nombre del Torneo:</span>
      <mat-form-field fxFlex="50">
        <input matInput type="text" formControlName="name">
        <mat-error *ngIf="newTournamentForm.get('name').hasError('required')">
          Nombre requerido
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Imagen del Torneo:</span>
      <img *ngIf="imgString" class="img-80" src="{{ imgString }}" alt="" />
      <a (click)="uploadNewTournamentImg()" mat-stroked-button color="primary">
        <i class="material-icons">add</i>
        {{imgString ? 'Cambiar' : 'Subir'}} imagen
      </a>
      <input (change)="handleNewImgUpload($event.target.files[0])" type="file" id="tournamentFileInput" hidden />
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Cantidad de Equipos: </span>
      <mat-form-field fxFlex="20">
        <input matInput (change)="checkTimePerDay()" type="number" formControlName="teamQuantity">
        <mat-error *ngIf="newTournamentForm.get('teamQuantity').hasError('required')">
          La cantidad de equipos es requerida
        </mat-error>
        <mat-error *ngIf="newTournamentForm.get('teamQuantity').hasError('max')">
          La cantidad de equipos no puede ser mayor a 20
        </mat-error>
        <mat-error *ngIf="newTournamentForm.get('teamQuantity').hasError('min')">
          La cantidad de equipos no puede ser menor a 4
        </mat-error>
        <mat-hint>La cantidad de equipos debe ser un numero entre 4 y 20</mat-hint>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Tamaño de Equipos: </span>
      <mat-form-field fxFlex="20">
        <mat-select formControlName="teamSize" (selectionChange)="checkTimePerDay()">
          <mat-option *ngFor="let capacity of fieldsCapacities" [value]="capacity">{{capacity.description / 2}}</mat-option>
        </mat-select>
        <span matSuffix>Jugadores &nbsp;</span>
        <mat-error *ngIf="newTournamentForm.get('teamSize').hasError('required')">
          El tamaño del equipos es requerido
        </mat-error>
        <mat-error *ngIf="newTournamentForm.get('teamSize').hasError('max')">
          El tamaño del equipo no puede ser mayor a 11
        </mat-error>
        <mat-error *ngIf="newTournamentForm.get('teamSize').hasError('min')">
          El tamaño del equipo no puede ser menor a 5
        </mat-error>
        <mat-hint>El tamaño del equipo debe ser un numero entre 5 y 11</mat-hint>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Inicio de Torneo: </span>
      <mat-form-field fxFlex="20">
        <input matInput (focus)="tournamentStartDate.open()" [matDatepicker]="tournamentStartDate" formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="tournamentStartDate"></mat-datepicker-toggle>
        <mat-datepicker #tournamentStartDate></mat-datepicker>
        <mat-error *ngIf="newTournamentForm.get('startDate').hasError('required')">
          Fecha de inicio es requerida
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Dias de Partidos: </span>
      <mat-form-field class="w-50">
        <mat-select formControlName="days" multiple>
          <mat-option *ngFor="let day of days" [value]="day">{{day.name}}</mat-option>
        </mat-select>
        <mat-error *ngIf="newTournamentForm.get('days').hasError('required')">
          Los dias de juego son requeridos
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Horarios de Partidos: </span>
      <span>Desde: </span>
      <mat-form-field>
        <input matInput (change)="checkTimePerDay()" type="text" placeholder="hh:mm" formControlName="matchTimeFrom">
        <!-- <mat-hint>Formato hh:mm</mat-hint> -->
      </mat-form-field>
      <span>Hasta: </span>
      <mat-form-field>
        <input matInput type="text" placeholder="hh:mm" formControlName="matchTimeTo">
        <!-- <mat-hint>Formato hh:mm</mat-hint> -->
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Costo Inscripción Torneo: </span>
      <mat-form-field fxFlex="20">
        <input matInput type="number" formControlName="entryCost">
        <mat-error *ngIf="newTournamentForm.get('entryCost').hasError('required')">
          El costo de inscripcion es requerido
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Descripción del Torneo: </span>
      <mat-form-field fxFlex="50">
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" formControlName="description"></textarea>
        <mat-error *ngIf="newTournamentForm.get('description').hasError('required')">
          Descripción requerida
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="2rem" fxLayoutAlign="start center">
      <span fxFlex="20">Sponsor:</span>
      <div class="sponsor__list flex-1" [ngClass]="{'d-none': !sponsors.length}">
        <div class="sponsor__item" *ngFor="let sponsor of sponsors; let i = index" matTooltip="{{sponsor.name}}">
          <a mat-icon-button (click)="removeSponsor(i)">
            <i class="material-icons">cancel</i>
          </a>
          <img src="{{sponsor.image}}" alt="{{sponsor.name}}">
        </div>
      </div>
      <div class="d-flex align-items-center w-25">
        <a mat-stroked-button color="primary" class="d-flex align-items-center" (click)="openSponsorDialog()">
          <i class="material-icons">add</i>
          Elegir sponsor
        </a>
      </div>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Mostrar Costo de Inscripción: </span>
      <mat-slide-toggle formControlName="showEntryCost"></mat-slide-toggle>
    </div>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Publicar: </span>
      <mat-slide-toggle formControlName="state"></mat-slide-toggle>
    </div>
    <div class="w-75" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2rem">
      <!-- <button mat-raised-button color="accent" type="submit" class="uppercase">Guardar Borrador</button> -->
      <button mat-raised-button color="primary" type="submit" [disabled]="!newTournamentForm.valid" class="uppercase">Guardar</button>
    </div>
  </div>
</form>